import {customElement, bindable} from "aurelia-framework";
import {AbstractCell} from './abstract-cell';
import * as _ from "lodash";

@customElement('sio-cell-default')
export class Default extends AbstractCell
{
    @bindable column;
    @bindable item;

    itemChanged()
    {
        this.bind();
    }
}